import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilm } from '@fortawesome/pro-light-svg-icons/faFilm';
import { faImage } from '@fortawesome/pro-light-svg-icons/faImage';
import { TypedMemo } from '../../../../../common/types';
import { Panel } from '../../../../../music24/components/primitives/Panel';
import { SMLButton } from '../../../../../music24/components/primitives/SMLButton';
import { mediaBlockMessages } from '../mediaBlockMessages';
import { MediaBlockPick } from './mediaBlockPick';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Media block editor; each part uses its own slice of it */
import styles from './MediaWidgetEditionView.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface MediaPickedRowProps {
  pick: MediaBlockPick;
  onChange: () => void;
}

/** The picked file folded into one row (design a4): the picture, the name, the facts and "Change file". */
const MediaPickedRowComponent: React.FC<MediaPickedRowProps> = ({ pick, onChange }) => {
  const intl = useIntl();
  const facts = pick.revision === null ? pick.facts : `${pick.facts} · r${pick.revision}`;

  return (
    <Panel nested className={styles.pickedRow} data-testid="media-picked-row">
      <span className={styles.pickedPicture}>
        {pick.pictureUrl === null ? (
          <FontAwesomeIcon icon={pick.kind === 'image' ? faImage : faFilm} />
        ) : (
          <img src={pick.pictureUrl} alt="" />
        )}
      </span>
      <span className={styles.pickedText}>
        <span className={styles.pickedName}>{pick.label}</span>
        <span className={styles.note}>{facts}</span>
        {pick.source.kind !== 'upload' && (
          <span className={styles.note}>
            {intl.formatMessage(
              pick.source.kind === 'cover' ? mediaBlockMessages.coverNote : mediaBlockMessages.newestRevision
            )}
          </span>
        )}
      </span>
      <SMLButton onClick={onChange}>{intl.formatMessage(mediaBlockMessages.changeFile)}</SMLButton>
    </Panel>
  );
};

export const MediaPickedRow = TypedMemo(MediaPickedRowComponent);
